
// ---------------------------------------------------------
// POST to cart/add.js returns the cart in JSON.
// ---------------------------------------------------------
if ((typeof Shopify) === 'undefined') {
    Shopify = {};
}

Shopify.addItem = function (variant_id, quantity, callback, attr, name_product) {

    console.log('addItem');

    var quantity = quantity || 0;
    if (typeof attr == 'undefined') {
        attr = [];
    }
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: quantity, id: variant_id, properties: attr },
        dataType: 'json',
        success: function (line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                jQuery.get('/cart?view=json', function (data) {
                    /*optional stuff to do after success */
                    jQuery('.cart-flyout').html(data);
                    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                });
                jQuery.getJSON('/cart.js', function (cart) {
                    jQuery(".la-cart-count").html(cart.item_count);
                });
                //remove_ajaxcart
                //jQuery('body').addClass('open-cart-aside');

                $.toast({
                    heading: 'PRODUTO ADICIONADO',
                    text: name_product,
                    icon: 'success',
                    position: 'top-right',
                    allowToastClose: true,
                    stack: 10
                });
            }
        },
        error: function (XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
}; 

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = function (variant_id, callback) {

    console.log('removeItem');

    var params = {
        type: 'POST',
        url: '/cart/change.js',
        beforeSend: function () {
            jQuery(".cart-flyout").addClass('removing-process');
        },
        data: 'quantity=0&id=' + variant_id,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            }
            else {
                jQuery.get('/cart?view=json', function (data) {
                    /*optional stuff to do after success */
                    jQuery('.cart-flyout').html(data);
                    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                });
                jQuery.getJSON('/cart.js', function (cart) {
                    jQuery(".la-cart-count").html(cart.item_count);
                });
            }
        },
        complete: function () {
            jQuery(".cart-flyout").removeClass('removing-process');
        },
        error: function (XMLHttpRequest, textStatus) {
            jQuery(".cart-flyout").removeClass('removing-process');
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };
    jQuery.ajax(params);
};  

function openAlert(icon, title, message){
    const swalWithBootstrapButtons = Swal.mixin({ 
        customClass: {
            confirmButton: 'btn border--primary-text p1 block full--w bg--primary-text color--primary-text--overlay hv--border--primary-accent hv--primary-accent--overlay hv-bg--primary-accent'
        },
        buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
        icon: icon,     
        title: title,
        text: message,   
        confirmButtonText: 'Ok',
    }).then((result) => {
        if (result.isConfirmed) {
            return;
        }
    });    
}